import http from '../http'
import { Res } from '../type'
import { HomeAdvertiseList, HomeAdvertiseListParams } from '../Models/HomeAdvertiseList'
import { CollegeList } from '../Models/CollegeList'
import { HomeConfig, HomeConfigParams } from '../Models/HomeConfig'
import { AppTabs, AppTabsParams } from '../Models/AppTabs'

export const getHomeAdvertiseList = (params: HomeAdvertiseListParams): Res<HomeAdvertiseList> => {
  return http.request({
    url: '/sands-lms/api/v1/publicize/page',
    method: 'post',
    data: params
  })
}

// 学院(学员端)相关接口-学院列表(按部门组织架构排序）
export const postCollegeList = (): Res<CollegeList> => {
  return http.request({
    url: '/sands-lms/api/v1/college/list',
    method: 'post'
  })
}

// 首页接口-首页接口获取(装修版)
export const postHomeConfig = (data: HomeConfigParams, loadingShow?: '0' | '1'): Res<HomeConfig> => {
  return http.request({
    url: '/sands-lms/api/v1/homePageDecorate/getInfo',
    method: 'post',
    data,
    headers: {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    loadingShow: loadingShow || '1'
  })
}

// 首页接口-导航栏获取
export const postAppTabs = (data: AppTabsParams): Res<AppTabs> => {
  return http.request({
    url: '/sands-lms/api/v1/decorate/decorate-navigation/navigation',
    method: 'post',
    data,
    toastShow: '0'
  })
}
